"use client";

import { ReactNode, useEffect, useRef, useState } from "react";
import PostCard from "./postcard";
import { Article } from "@/types/article.type";

export const PostSlider = ({ data }: { data: Article[] }) => {
  const [scrollPos, setScrollPos] = useState(0);
  const [maxScroll, setMaxScrollPos] = useState(data.length - 3);
  const [ITEM_SCROLL, setITEM_SCROLL] = useState<number>(340);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const mobiled = () => {
      if (window.innerWidth < 640) {
        setITEM_SCROLL(277);
        setMaxScrollPos(data.length - 1);
      } else {
        setITEM_SCROLL(340);
        setMaxScrollPos(data.length - 3);
      }
    };

    mobiled();

    window.addEventListener("resize", mobiled);

    return () => window.removeEventListener("resize", mobiled);
  }, []);

  // const maxScroll = data.length - 1;

  const handleScroll = (scrollAmount: number) => {
    if (!containerRef.current) return;

    const newScrollPos = clamp(
      scrollPos + scrollAmount * ITEM_SCROLL,
      0,
      ITEM_SCROLL * maxScroll,
    );

    setScrollPos(newScrollPos);
    containerRef.current.scrollLeft = newScrollPos;
  };

  const isLeftDisabled = scrollPos === 0;
  const isRightDisabled = scrollPos === ITEM_SCROLL * maxScroll;

  if (!data) return;

  return (
    <div className="flex flex-row items-center justify-center gap-3 sm:gap-8 w-full h-auto">
      <button
        className={`size-6 md:size-10 bg-natura-primary rounded-full flex items-center justify-center py-3 md:py-5 px-1.5 md:px-2.5 cursor-pointer ${isLeftDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-natura-darker-1"} group`}
        onClick={() => {
          if (!isLeftDisabled) handleScroll(-1);
        }}
        disabled={isLeftDisabled}
      >
        <svg
          className={`size-3 md:size-6 fill-natura-white `}
          viewBox="0 0 24 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.93934 10.4393C0.353553 11.0251 0.353553 11.9749 0.93934 12.5607L10.4853 22.1066C11.0711 22.6924 12.0208 22.6924 12.6066 22.1066C13.1924 21.5208 13.1924 20.5711 12.6066 19.9853L4.12132 11.5L12.6066 3.01472C13.1924 2.42893 13.1924 1.47919 12.6066 0.893398C12.0208 0.307611 11.0711 0.307611 10.4853 0.893398L0.93934 10.4393ZM22 13C22.8284 13 23.5 12.3284 23.5 11.5C23.5 10.6716 22.8284 10 22 10V13ZM2 13H22V10H2V13Z" />
        </svg>
      </button>

      <div
        className="flex flex-row gap-6 sm:gap-12 items-start justify-start w-[253px] min-h-[295px] sm:min-w-[292px] sm:max-w-[292px] md:min-w-[972px] md:max-w-[972px] overflow-x-hidden scroll-smooth"
        ref={containerRef}
      >
        {data.map((c) => {
          return (
            <PostCard
              key={c.id}
              thumbnail={c.thumbnail || "/stats/image_1.webp"}
              title={c.title}
              description={c.excerpt}
              writerPicture={c.authorPhoto ?? ""}
              writerName={c.author}
              date={c.createdAt ?? new Date(Date.now())}
            />
          );
        })}
      </div>

      <button
        className={`group size-6 md:size-10 bg-natura-primary rounded-full flex items-center justify-center py-3 md:py-5 px-1.5 md:px-2.5 cursor-pointer ${isRightDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-natura-darker-1"}`}
        onClick={() => {
          if (!isRightDisabled) handleScroll(1);
        }}
        disabled={isRightDisabled}
      >
        <svg
          className={`size-3 md:size-6 fill-natura-white`}
          viewBox="0 0 24 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2 10C1.17157 10 0.5 10.6716 0.5 11.5C0.5 12.3284 1.17157 13 2 13V10ZM23.0607 12.5607C23.6464 11.9749 23.6464 11.0251 23.0607 10.4393L13.5147 0.893398C12.9289 0.307611 11.9792 0.307611 11.3934 0.893398C10.8076 1.47919 10.8076 2.42893 11.3934 3.01472L19.8787 11.5L11.3934 19.9853C10.8076 20.5711 10.8076 21.5208 11.3934 22.1066C11.9792 22.6924 12.9289 22.6924 13.5147 22.1066L23.0607 12.5607ZM2 13H22V10H2V13Z" />
        </svg>
      </button>
    </div>
  );
};

function clamp(num: number, min: number, max: number) {
  return num <= min ? min : num >= max ? max : num;
}
